import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import NotFoundImg from 'assets/img/404.png';
import RouterPaths from '../constants/RouterPaths';

const NotFound = () => {
  return (
    <div className="not-found">
      <img src={NotFoundImg} alt="" />
      <p className="not-found-text">Houston, we have a problem</p>
      <NavLink
        to={RouterPaths.HOMEPAGE}
        className="auth-button auth-button--active"
        activeClassName="auth-button--active"
      >
        Go to home page
      </NavLink>
    </div>
  );
};
export default withRouter(NotFound);
